"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const entrypoints_1 = require("./entrypoints");
const pay_checkout_1 = require("./entrypoints/checkout/pay-checkout");
const search_checkout_consignment_click_and_collect_addresses_1 = require("./entrypoints/checkout/search-checkout-consignment-click-and-collect-addresses");
const search_checkout_consignment_home_delivery_addresses_1 = require("./entrypoints/checkout/search-checkout-consignment-home-delivery-addresses");
const sdk = (apiHost, config) => {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, {
        ...config,
        useHttpError: true,
        callerId: config.callerId
    });
    return {
        duplicateList: (0, entrypoints_1.duplicateList)(client),
        getOnePurchaseOrder: (0, entrypoints_1.getOnePurchaseOrder)(client, config.logger),
        getOneShoppingList: (0, entrypoints_1.getOneShoppingList)(client, config.logger),
        addPromoCodeToCart: (0, entrypoints_1.addPromoCodeToCart)(client),
        removePromoCodeFromCart: (0, entrypoints_1.removePromoCodeFromCart)(client),
        addPromoCodeToList: (0, entrypoints_1.addPromoCodeToList)(client),
        removePromoCodeFromList: (0, entrypoints_1.removePromoCodeFromList)(client),
        getDeliveryAddresses: (0, entrypoints_1.getDeliveryAddresses)((0, entrypoints_1.getCheckoutConsignmentHomeDeliveryAddresses)(client), (0, entrypoints_1.getCheckoutConsignmentPickupPointDeliveryAddresses)(client), (0, search_checkout_consignment_click_and_collect_addresses_1.searchCheckoutConsignmentClickAndCollectAddresses)(client)),
        getHomeDeliveryAddresses: (0, entrypoints_1.getCheckoutConsignmentHomeDeliveryAddresses)(client),
        searchHomeDeliveryAddresses: (0, search_checkout_consignment_home_delivery_addresses_1.searchCheckoutConsignmentHomeDeliveryAddresses)(client),
        getPickupPointDeliveryAddresses: (0, entrypoints_1.getCheckoutConsignmentPickupPointDeliveryAddresses)(client),
        searchDeliveryOptions: (0, entrypoints_1.searchDeliveryOptions)((0, entrypoints_1.searchHomeDeliveryOptions)(client), (0, entrypoints_1.searchPickupPointDeliveryOptions)(client), (0, entrypoints_1.searchClickAndCollectDeliveryOptions)(client)),
        searchClickAndCollectDeliveryOptions: (0, entrypoints_1.searchClickAndCollectDeliveryOptions)(client),
        searchHomeDeliveryOptions: (0, entrypoints_1.searchHomeDeliveryOptions)(client),
        searchPickupPointDeliveryOptions: (0, entrypoints_1.searchPickupPointDeliveryOptions)(client),
        selectDeliveryOptions: (0, entrypoints_1.selectDeliveryOptions)(client),
        getCheckoutForDelivery: (0, entrypoints_1.getCheckoutForDelivery)(client),
        getCheckoutLineItemsForDelivery: (0, entrypoints_1.getCheckoutLineItemsForDelivery)(client),
        selectCheckoutLineItemsDeliveryOptions: (0, entrypoints_1.selectCheckoutLineItemsDeliveryOptions)(client),
        getCheckoutForPayment: (0, entrypoints_1.getCheckoutForPayment)(client),
        getPricedOffers: (0, entrypoints_1.getPricedOffers)(client),
        addLineItemsFromLogisticOrderToCart: (0, entrypoints_1.addLineItemsFromLogisticOrderToCart)(client),
        searchDynamicSegments: (0, entrypoints_1.searchDynamicSegments)(client),
        cancelConsignment: (0, entrypoints_1.cancelConsignment)(client),
        sendInvoices: (0, entrypoints_1.sendInvoices)(client),
        cancelPayment: (0, entrypoints_1.cancelPayment)(client),
        regenerateCode: (0, entrypoints_1.regenerateCode)(client),
        validateCode: (0, entrypoints_1.validateCode)(client),
        searchClickAndCollectAddresses: (0, search_checkout_consignment_click_and_collect_addresses_1.searchCheckoutConsignmentClickAndCollectAddresses)(client),
        negotiateLineItem: (0, entrypoints_1.negotiateLineItem)(client),
        payCheckout: (0, pay_checkout_1.payCheckout)(client),
        removeLineItemNegotiation: (0, entrypoints_1.removeLineItemNegotiation)(client)
    };
};
exports.sdk = sdk;
